import React, { useEffect, useState } from "react";
import calender from "../../assets/calender.png";
import statusIcon from "../../assets/orders/status.png";
import { Button, Modal, Radio, Space } from "antd";
import Completed from "./Completed";
import Cancelled from "./Cancelled";
import prev from "../../assets/previewRequests/prev.png";
import { fetchPreviewId } from "../../redux/showPreviewIdSlice";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const PreviewRequestFinished = ({
  id,
  isoDate,
  statuss,
  description,
  addresss,
  area,
  levels_count,
  units_count,
  construction_type,
  rates,
  rates_comment,
  attach_file
}) => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalCancel, setIsModalCancel] = useState(false);
  // const [orderStatus, setOrderStatus] = useState("Complete");

  const showModal = (status) => {
    // setOrderStatus(status);
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const showModalCancel = () => {
    setIsModalCancel(true);
  };
  const handleOkCancel = () => {
    setIsModalCancel(false);
  };
  const handleCancelCancel = () => {
    setIsModalCancel(false);
  };

  const dispatch = useDispatch();

  const { showPreviewId, status, error } = useSelector(
    (state) => state.showPreviewId
  );

  useEffect(() => {
    dispatch(fetchPreviewId(id));
  }, [dispatch]);

  const [value, setValue] = useState(1);
  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const dateObject = new Date(isoDate);

  const day = String(dateObject.getDate()).padStart(2, "0");
  const month = String(dateObject.getMonth() + 1).padStart(2, "0");
  const year = dateObject.getFullYear();

  const formattedDate = `${day}-${month}-${year}`;

  const formattedTime = dateObject.getHours() < 21 ? "21:00" : "21:00";

  const renderModalContent = () => {
    if (statuss === "completed" || statuss === "rated") {
      return (
        <Completed
          id={id}
          date={formattedDate}
          time={formattedTime}
          description={description}
          addresss={addresss}
          area={area}
          levels_count={levels_count}
          units_count={units_count}
          statuss={statuss}
          images={showPreviewId}
          construction_type={construction_type}
          rates={rates}
          rates_comment={rates_comment}
          attach_file={attach_file}
        />
      );
    } else if (statuss === "cancelled") {
      return (
        <Cancelled
          id={id}
          date={formattedDate}
          time={formattedTime}
          description={description}
          addresss={addresss}
          area={area}
          levels_count={levels_count}
          units_count={units_count}
          statuss={statuss}
          images={showPreviewId}
          construction_type={construction_type}
        />
      );
    }
  };

  return (
    <div>
      <div className="bg-white shadow-2xl rounded-2xl mt-4 p-4">
        <div className="flex justify-between ">
          <div className="lg:flex items-center">
            <div className="bg-[#FCFBFA] p-3 rounded-2xl">
              <img src={prev} className="w-[80px]" />
            </div>
            <p className="ml-3 text-[#737E91] font-semibold max-lg:mt-3">
            {t("Order number")} 
              <span className="text-[#283D63] font-semibold">#{id}</span>
              <div className="flex items-center mt-3">
                <img src={calender} className={`w-[18px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#283D63] font-medium">
                  {formattedDate} | {formattedTime}
                </p>
              </div>
              <div className="flex items-center mt-3">
                <img src={statusIcon} className={`w-[18px] ${language == "en" ? "mr-2" : "ml-2"}`} />
                <p className="text-[#737E91]">{t("Status")}</p>
                <p className="text-[#283D63] ml-2">{statuss}</p>{" "}
              </div>
            </p>
          </div>
        </div>

        <div className="flex justify-center my-5">
          <div>
            <button
              onClick={() => showModal("final_report")}
              className="bg-[#FE9B71] text-white rounded-full px-8 max-lg:px-3 h-10 mx-3"
            >
              {t("Preview order")}
            </button>
            <Modal
              title="Request View"
              className="orderModal"
              open={isModalOpen}
              onOk={handleOk}
              onCancel={handleCancel}
              footer={null}
            >
              <div className="mt-6">{renderModalContent()}</div>
            </Modal>
          </div>

          {statuss === "completed" && (
            <div>
              <button
                onClick={showModalCancel}
                className="text-[#FE9B71] rounded-full h-10 border-2 border-[#FE9B71] px-8 max-lg:px-3"
              >
                {t("View receipt")}
              </button>

              {/* <Modal
    title="Are you sure you want to cancel?"
    className="orderModal orderModalPricing w_small_modal"
    open={isModalCancel}
    onOk={handleOkCancel}
    onCancel={handleCancelCancel}
    footer={null}
  >
    <div className="mx-5 my-5">
      <div>
        <Radio.Group onChange={onChange} value={value} className="custome_radio custome_radio_color">
          <Space direction="vertical">
            <Radio value={1}>I was trying the app</Radio>
            <Radio value={2}>
              I will try ordering this service later
            </Radio>
            <Radio value={3}>
              Appointed technician is not replying{" "}
            </Radio>
            <Radio value={4}>No reason</Radio>
            <Radio value={4}>Other</Radio>
          </Space>
        </Radio.Group>
      </div>

    </div>
  </Modal> */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PreviewRequestFinished;
